module.exports = __webpack_public_path__ + "static/img/zhuanpu-bg.385fbf7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/zhuanpu-bg.png
// module id = Il9Q
// module chunks = 1